var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.591,
    height: 30.271,
    viewBox: "0 0 27.591 30.271",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9081"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 223",
    transform: "translate(8.287 21.689)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M11.087 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 224",
    transform: "translate(8.287 15.261)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M11.087 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 225",
    transform: "translate(8.287 8.847)",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    d: "M4.231 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7840",
    d: "M19.421.75 7.613.756C3.375.782.751 3.571.751 7.824v14.122c0 4.275 2.644 7.075 6.919 7.075h11.807c4.238-.026 6.864-2.816 6.864-7.07V7.824C26.342 3.549 23.7.75 19.421.75z",
    style: {
      fillRule: "evenodd",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    },
    transform: "translate(.249 .25)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterList);
export default __webpack_public_path__ + "static/media/master_list.e9854de7ee04abc1cb8ddb60c7577e98.svg";
export { ForwardRef as ReactComponent };